module.exports = __webpack_public_path__ + "img/reset-icon.2a7be42f.png";